import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


export interface NotificationInterface {
  icon: string;
  link: string;
  color: string;
  title: string;
  created: string;
  seen: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private _notifications: Array<NotificationInterface>;
  private _loadedNotifications: boolean = false;

  public get notifications(): Array<NotificationInterface> {
    return this._notifications;
  }

  public get hasNotifications(): boolean {
    return this._notifications && this._notifications.length > 0 && this._loadedNotifications;
  }
  
  public get hasUnseenNotifications(): boolean {
    let unseenNotification = false;
    this._notifications.map((notification: NotificationInterface) => !notification.seen ? unseenNotification = true : null);
    return unseenNotification;
  }
  
  constructor(private http: HttpClient) {
    this._notifications = [];
  }

  public async markNotificationsSeen(userId: string) {
    const SEEN_NOTIFICATIONS: string = `https://us-central1-relayclients.cloudfunctions.net/seenNotificationsForUser?user=${userId}`;
    const notificationResponse: any = await this.http.get(SEEN_NOTIFICATIONS).toPromise();
    console.log(notificationResponse);
    this._notifications.map((notification: NotificationInterface) => {
      notification.seen = true;
    });
  }

  public async getNotifications(userId: string) { 
    if (this._notifications && this._notifications.length > 0) return;

    const GET_NOTIFICATIONS: string = `https://us-central1-relayclients.cloudfunctions.net/getNotificationsForUser?user=${userId}`;
    const notificationResponse: any = await this.http.get(GET_NOTIFICATIONS).toPromise();
    if (notificationResponse) {
      console.log(notificationResponse);
      this._notifications = [];
      for (const key in notificationResponse) {
        if (notificationResponse.hasOwnProperty(key)) {
          const notificationArticle = notificationResponse[key];
          this._notifications.push(notificationArticle);
        }
      }
      this._loadedNotifications = true;
    }
  }
}
